import { render, staticRenderFns } from "./PagesSumRegionReportComponent.vue?vue&type=template&id=da009c9e&scoped=true"
import script from "./PagesSumRegionReportComponent.vue?vue&type=script&lang=js"
export * from "./PagesSumRegionReportComponent.vue?vue&type=script&lang=js"
import style0 from "./PagesSumRegionReportComponent.vue?vue&type=style&index=0&id=da009c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da009c9e",
  null
  
)

export default component.exports